import { Component, OnInit, Input, OnChanges, Inject } from '@angular/core';
import { Gauge } from 'gaugeJS';
import { DOCUMENT } from '@angular/common';
import { Indicator, RecessionData } from '../indicator/indicator';
import { IndicatorGaugeConfigService } from './indicator-gauge.config';
import { Logger } from '@utils/logger';

const logger = Logger.getLogger('IndicatorGaugeComponent');
@Component({
  selector: 'aor-indicator-gauge',
  templateUrl: './indicator-gauge.component.html',
  styleUrls: ['./indicator-gauge.component.scss'],
})
export class IndicatorGaugeComponent implements OnInit, OnChanges {
  @Input() recessionData?: RecessionData;
  @Input() asOfDate: string;

  gauge: Gauge;
  config: object;

  @Input() brLabels: object = {};

  constructor(
    @Inject(DOCUMENT) private documentRef: Document,
    private configService: IndicatorGaugeConfigService
  ) {
    this.getConfig();
  }

  getConfig(): void {
    this.configService.getConfig().subscribe((data) => (this.config = data));
  }

  calculateIndicatorWeight(indicator: Indicator): number {
    return indicator.data.value * (indicator.data.weight / 100);
  }

  tallyIndicatorWeights(total: number, weightedScore: number): number {
    return total + weightedScore;
  }

  calculateRecessionScore(): number {
    let total = 0;

    if (this.recessionData) {
      const keys = Object.keys(this.recessionData);
      for (let i = 1; i < keys.length; i++) {
        total =
          total +
          this.recessionData[keys[i]]
            .map(this.calculateIndicatorWeight)
            .reduce(this.tallyIndicatorWeights);
      }
    }

    return total;
  }

  updateGauge(): void {
    const recessionScore = this.calculateRecessionScore();
    this.gauge?.set(recessionScore);
  }

  ngOnChanges() {
    this.updateGauge();
  }

  ngOnInit(): void {
    const target = this.documentRef.getElementById('indicator-gauge');
    logger.debug(this.config);
    this.gauge = new Gauge(target).setOptions(this.config);
    this.gauge.maxValue = 5.5;
    this.gauge.setMinValue(1);

    this.updateGauge();
  }
}
